export const actionTypes = {
  OPEN: 'MENU_MODAL:OPEN',
  CLOSE: 'MENU_MODAL:CLOSE',
  TOGGLE_SEARCH: 'MENU:TOGGLE_SEARCH',
  CHANGE_SEARCH_QUERY: 'MENU:CHANGE_SEARCH_QUERY',
}

const actions = {
  openImageModal: () => ({ type: actionTypes.OPEN }),
  closeImageModal: () => ({ type: actionTypes.CLOSE }),
};

export default actions;
